import React, { useEffect, useRef, useState } from "react";
import { Layout, Button, Modal } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { ImageUrl } from "../../helpers/Functions";
import "./b2b-training.css";

function Homepage() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const videoRef = useRef(null);
  const [modal2Open, setModal2Open] = useState(false);

  React.useEffect(() => {
    if (!user && !token) {
      navigate("/", { replace: true });
    }
  }, [user, token, navigate]);

  useEffect(() => {
    if (modal2Open && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.log("Autoplay failed:", error);
      });
    }
  }, [modal2Open]);

  const data1 = [
    { title: "HubSpot" },
    { title: "Salesforce." },
    { title: "Shopify." },
    { title: "Google Analytics, FB pixel, and more." },
  ];

  const data4 = [
    { title: "Sell classes directly on the LMS or use an existing store." },
    { title: "Provide course access to users directly after purchase." },
  ];

  return (
    <Layout className="b2b-page">
      <section
        className="b2b-hero"
        style={{ backgroundImage: `url(${ImageUrl("new-45.png")})` }}
      >
        <div className="b2b-hero-overlay" aria-hidden />
        <div className="b2b-wrap b2b-hero-inner">
          <div className="b2b-hero-copy">
            <span className="b2b-hero-badge">INTEGRATIONS & API</span>
            <h1 className="fontFamily1 b2b-hero-title">
              Connect WrightCo Academy With{" "}
              <span>Existing Tools</span>
            </h1>
            <p className="fontFamily1 b2b-hero-sub">
              Earn revenue from your courses and programs, by selling them
              online with our customizable landing pages, or by connecting them
              to your own eCommerce site.
            </p>
            <div className="b2b-hero-actions">
              {!token && (
                <Button
                  type="primary"
                  className="b2b-hero-btn-primary"
                  onClick={() => navigate("/signup")}
                >
                  Register Now
                </Button>
              )}
              <Button
                className="b2b-hero-btn-outline"
                onClick={() => setModal2Open(true)}
              >
                See The Platform <FaArrowRight />
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--white">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-media">
              <img src={ImageUrl("new-46.png")} alt="" loading="lazy" />
            </div>
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg4.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">
                Bring Marketing & Sales to your eLearning Platform
              </h2>
              <p>
                Connect WrightCo Acadmey to your CRM and other marketing tools,
                to manage eLearning and business goals together.
              </p>
              <ul className="b2b-check-list">
                {data1.map((item) => (
                  <li key={item.title}>
                    <FaCheckCircle aria-hidden />
                    <span>{item.title}</span>
                  </li>
                ))}
              </ul>
              <Button
                className="b2b-btn-ghost"
                onClick={() => navigate("/pricingPlans")}
              >
                See Pricing
              </Button>
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--navy">
        <div className="b2b-wrap">
          <div className="b2b-section-intro">
            <span className="b2b-section-kicker">
              <img src={ImageUrl("miniImg2.png")} alt="" />
            </span>
            <h2 className="fontFamily1 b2b-section-title">
              Customize the LMS with REST API & JavaScript
            </h2>
            <p className="fontFamily1 b2b-section-lead">
              The sky is the limit with our flexible REST API that allows you to
              build out anything you like with the data from WrighCo Academy. Use
              Custom JavaScript to customize WrighCo Academy as well.
            </p>
            {!token && (
              <div className="b2b-cta-center">
                <Button
                  className="b2b-btn-light"
                  onClick={() => navigate("/signup")}
                >
                  Get Started
                </Button>
              </div>
            )}
          </div>
          <div className="b2b-split-media" style={{ maxWidth: 980, margin: "0 auto" }}>
            <img src={ImageUrl("new-47.png")} alt="" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--white">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">Integrate with your eCommerce Store</h2>
              <p>
                Advertise and sell tickets to upcoming in-person classes, online
                courses, and webinars on your website.
              </p>
              <ul className="b2b-check-list">
                {data4.map((item) => (
                  <li key={item.title}>
                    <FaCheckCircle aria-hidden />
                    <span>{item.title}</span>
                  </li>
                ))}
              </ul>
              <Button
                className="b2b-btn-ghost"
                onClick={() => navigate("/pricingPlans")}
              >
                See Pricing
              </Button>
            </div>
            <div className="b2b-split-media">
              <img src={ImageUrl("new-16.png")} alt="" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--muted">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-media">
              <img src={ImageUrl("new-48.png")} alt="" loading="lazy" />
            </div>
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg4.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">Connect with Webinar Tools</h2>
              <p>
                Connect with third-party apps to create the ultimate eLearning
                platform. With our integrations and developer-friendly API, your
                learners can continue their education and train online using
                familiar business tools.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--navy">
        <div className="b2b-wrap">
          <div className="b2b-section-intro">
            <span className="b2b-section-kicker">
              <img src={ImageUrl("miniImg2.png")} alt="" />
            </span>
            <h2 className="fontFamily1 b2b-section-title">
              Log in with Single Sign-on and 2-Step Verification
            </h2>
            <p className="fontFamily1 b2b-section-lead">
              Eliminate password fatigue by letting employees log in with their
              company credentials (Single-Sign on). Mitigate security risks with
              2-step verification.
            </p>
            {!token && (
              <div className="b2b-cta-center">
                <Button
                  className="b2b-btn-light"
                  onClick={() => navigate("/signup")}
                >
                  Get Started
                </Button>
              </div>
            )}
          </div>
          <div className="b2b-split-media" style={{ maxWidth: 980, margin: "0 auto" }}>
            <img src={ImageUrl("new-49.png")} alt="" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--muted">
        <div className="b2b-wrap">
          <div className="b2b-split">
            <div className="b2b-split-copy">
              <img
                src={ImageUrl("miniImg4.png")}
                alt=""
                className="b2b-section-kicker"
              />
              <h2 className="fontFamily1">
                Notify external systems automatically
              </h2>
              <p>
                Using Webhooks, automatically send notifications to outside
                systems when actions occur in the LMS.
              </p>
              <Button
                className="b2b-btn-ghost"
                onClick={() => navigate("/pricingPlans")}
              >
                See Pricing
              </Button>
            </div>
            <div className="b2b-split-media">
              <img src={ImageUrl("new-50.png")} alt="" loading="lazy" />
            </div>
          </div>
        </div>
      </section>

      <section className="b2b-section b2b-section--white">
        <div className="b2b-wrap">
          <div className="b2b-section-intro" style={{ marginBottom: 0 }}>
            <h2 className="fontFamily1 b2b-section-title">
              Efficiently Sell Courses & Webinars Online
            </h2>
            {!token && (
              <div className="b2b-cta-center">
                <Button
                  className="b2b-hero-btn-primary"
                  onClick={() => navigate("/signup")}
                >
                  Get Started
                </Button>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="b2b-trainer">
        <div className="b2b-wrap">
          <div className="b2b-trainer-card">
            <h3>We&apos;re Looking for Trainers</h3>
            <h3>Teach. Create. Earn.</h3>
            <p>
              Are you passionate about teaching? Ready to share your expertise,
              connect with professionals, and make a meaningful impact, all
              while earning extra income?
            </p>

            <h4>You&apos;ve come to the right place.</h4>
            <p>
              At WrightCo Academy, we are building a network of world-class
              trainers and industry experts dedicated to developing high-quality
              courseware for professionals in early care and education. If
              you&apos;re an expert in your field with a desire to teach,
              we&apos;d love to have you on board!
            </p>

            <h3>Why Join Us?</h3>
            <ul>
              <li>
                <p>
                  ✅ Expand Your Reach – Share your knowledge with a broad
                  audience of professionals.
                </p>
              </li>
              <li>
                <p>
                  ✅ Boost Your Visibility – Gain recognition as a trusted expert
                  in your industry.
                </p>
              </li>
              <li>
                <p>
                  ✅ Join a Thriving Community – Connect with like-minded trainers
                  and industry leaders.
                </p>
              </li>
              <li>
                <p>
                  ✅ Earn Passive Income – Our fair and flexible revenue-sharing
                  model ensures unlimited earning potential.
                </p>
              </li>
            </ul>

            <h3>What It Takes to Be a WrightCo Trainer</h3>
            <ul>
              <li>
                <p>
                  ✔ <strong>Passion for Teaching</strong> – A commitment to
                  sharing knowledge and empowering others.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Industry Expertise</strong> – Relevant certifications
                  and experience in your domain.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Strong Communication Skills</strong> – Ability to
                  present information effectively.
                </p>
              </li>
              <li>
                <p>
                  ✔ <strong>Commitment to Excellence</strong> – Willingness to
                  develop and deliver high-quality training.
                </p>
              </li>
            </ul>
            <h4>Ready to Make an Impact?</h4>
            <p>
              Join WrightCo Academy today and take the next step in your teaching
              journey.
            </p>
          </div>
        </div>
      </section>

      <Modal
        className="b2b-video-modal"
        centered
        open={modal2Open}
        onOk={() => setModal2Open(false)}
        onCancel={() => setModal2Open(false)}
        width={1000}
        footer={false}
      >
        <div style={{ padding: "24px 12px" }}>
          <video width="auto" height="auto" ref={videoRef} controls>
            <source src="https://react.customdev.solutions:3012/Uploads/tutorVideo.mp4" />
            <source src="movie.ogg" type="video/ogg" />
          </video>
        </div>
      </Modal>
    </Layout>
  );
}

export default Homepage;
